import blog from './blog'
import encyclopedia from './encyclopedia'
import faq from './faq'
import jobOffers from './job-offers'
import pages from './pages'
import projects from './projects'
import referralActions from './referral-actions'
import products from './products'
import videoTestimonials from './video-testimonials'

const cmsLib = {
  ...blog,
  ...encyclopedia,
  ...faq,
  ...jobOffers,
  ...pages,
  ...projects,
  ...referralActions,
  ...products,
  ...videoTestimonials
}

export default cmsLib
